/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for [object Object] services
 */
@Injectable({
  providedIn: 'root',
})
export class ObjectObjectConfiguration {
  rootUrl: string = 'https://adminbetaspace.empatydev.net/api/v1';
}

export interface ObjectObjectConfigurationInterface {
  rootUrl?: string;
}
